import React from 'react';
import { Search } from '@loomstateorg/shared-frontend';
import HeaderLogo from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/header/header-logo';
import HeaderNavigationDesktop from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/header/header-navigation/header-navigation-desktop';
import HeaderNavigationMobile from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/header/header-navigation/header-navigation-mobile';
import { HeaderProps } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/header/types';
import UtilitySection from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/header/utility-section';

const Header: React.FC<HeaderProps> = ({
  navLinks,
  categories,
  logo,
  logoMobile,
  logoLink,
  logoLinkMobile,
  src,
  icon,
  search,
  logoScale = '1x',
  backgroundClassName = '',
  topRowClassName = 'mb-10 grid w-full grid-cols-[1fr_auto_1fr] items-center px-16 md:px-24 lg:mb-0 lg:px-20 xl:px-48',
  lazyPermissions = false,
  mobileDrawerClassName,
  dashboardDefaultMessage,
  overlayClassName,
  panelClassName,
  accountPanelPositionClassName,
  accountDropdownLook,
  rowSurfaceClassName,
  navLinkTypographyClassName,
  searchDrawerClassName,
  searchSubmitButtonClassName,
  searchIconFocusedClassName,
  imageApi,
}) => {
  return (
    <header
      className={`relative h-fit w-full border-b-[1.5px] border-neutral-400 pt-20 pb-8 md:pb-20 ${backgroundClassName}`}
      data-testid="header"
    >
      <div aria-label="Top" className={topRowClassName}>
        <div className="flex items-center">
          <HeaderNavigationMobile
            src={src}
            logo={logo}
            links={navLinks}
            logoLink={logoLink}
            logoScale={logoScale}
            lazyPermissions={lazyPermissions}
            drawerClassName={mobileDrawerClassName}
            dashboardDefaultMessage={dashboardDefaultMessage}
            imageApi={imageApi}
          />
          <div className="hidden lg:block" data-testid="desktop-logo">
            <HeaderLogo
              src={src}
              logo={logo}
              logoLink={logoLink}
              logoScale={logoScale}
              imageApi={imageApi}
              imageClassName="flex justify-center text-center text-16 font-bold md:text-28"
            />
          </div>
        </div>
        <div>
          <div className="lg:hidden" data-testid="mobile-logo">
            <HeaderLogo
              src={src}
              logo={logoMobile || logo}
              logoLink={logoLinkMobile || logoLink}
              logoScale={logoScale}
              imageApi={imageApi}
              imageObjectPosition="center"
              imageClassName="flex justify-center text-center text-16 font-bold"
            />
          </div>
          <HeaderNavigationDesktop
            links={navLinks}
            categories={categories}
            search={search}
            navLinkTypographyClassName={navLinkTypographyClassName}
            searchDrawerClassName={searchDrawerClassName}
            searchSubmitButtonClassName={searchSubmitButtonClassName}
            searchIconFocusedClassName={searchIconFocusedClassName}
          />
        </div>
        <div className="flex justify-end" data-testid="utility-section">
          <UtilitySection
            icon={icon}
            overlayClassName={overlayClassName}
            panelClassName={panelClassName}
            accountPanelPositionClassName={accountPanelPositionClassName}
            accountDropdownLook={accountDropdownLook}
            rowSurfaceClassName={rowSurfaceClassName}
          />
        </div>
      </div>
      {!!search && (
        <div
          className="relative block w-full border-t border-neutral-400 px-16 py-8 md:px-24 lg:hidden lg:px-20 xl:px-48"
          data-testid="mobile-search"
        >
          <Search
            categories={categories}
            submitButtonClassName={searchSubmitButtonClassName}
            searchIconFocusedClassName={searchIconFocusedClassName}
          />
        </div>
      )}
    </header>
  );
};
export default Header;
